import React from "react";
import { Link } from "react-router-dom";

/*
    The customer's plan, described.

    `apiPlan` is the matching card from planCardData; `planLabel` is the
    server's own name for the plan from GET /me/entitlement.

    The no-card branch stays exactly as it was and is not decoration: the
    Enterprise, Unlimited and Custom 10 Courses plans exist in Stripe with no
    entry in planCardData, and every field below resolves to undefined for
    them. Before backend#103 that rendered a blank panel reading "$ per
    month" at a paying customer.
*/

const formatPrice = (amount) => {
  if (amount === 0) return "Free";
  if (typeof amount === "number") return `$${amount} per month`;
  // Static Data's "120,000**" is a string, and is a one-time fee.
  return amount ? `$${amount}` : null;
};

const MyApiPlan = ({ apiPlan, planLabel }) => {
  if (!apiPlan) {
    return (
      <>
        <p className="account__fact account__fact--strong">
          {planLabel || "Your plan"}
        </p>
        <p className="account__fact">
          Contact{" "}
          <a href="mailto:apisupport@golfbert.com" className="link-to">
            apisupport@golfbert.com
          </a>{" "}
          for the details of this plan.
        </p>
      </>
    );
  }

  const price = formatPrice(apiPlan.unit_amount);
  // The sample plan states no support terms anywhere in this codebase, so the
  // whole block is omitted for it rather than invented or left half-empty.
  const hasSupport = Boolean(
    apiPlan.newCourse || apiPlan.submit || apiPlan.report
  );

  return (
    <>
      <p className="account__fact">
        <span className="account__fact-label">Plan:</span>{" "}
        {apiPlan.nickname || planLabel}
      </p>

      {apiPlan.subTitle && <p className="account__fact">{apiPlan.subTitle}</p>}

      {price && (
        <p className="account__fact">
          <span className="account__fact-label">Price:</span> {price}
        </p>
      )}

      {apiPlan.callPerMon && (
        <p className="account__fact">
          <span className="account__fact-label">Call limit:</span>{" "}
          {apiPlan.callPerMon}
        </p>
      )}

      {apiPlan.additionalApi && (
        <p className="account__fact">{apiPlan.additionalApi}</p>
      )}

      {hasSupport && (
        <>
          <p
            id="included-support"
            className="account__fact account__fact--strong mt-3"
          >
            Included Support:
          </p>
          <ul
            aria-labelledby="included-support"
            className="account__fact pl-4 mb-0"
          >
            {apiPlan.newCourse && <li>{apiPlan.newCourse}</li>}
            {apiPlan.submit && <li>{apiPlan.submit}</li>}
            {apiPlan.report && <li>{apiPlan.report}</li>}
          </ul>
        </>
      )}

      {apiPlan.nickname === "Single Golf Course" && (
        <p className="account__fact mt-3 mb-0">
          <Link to="/api/plans" className="link-to fw--500">
            Upgrade to All Courses
          </Link>
        </p>
      )}
    </>
  );
};

export default MyApiPlan;
